import { render, staticRenderFns } from "./GetStartedForm.vue?vue&type=template&id=421bf6b2&"
import script from "./GetStartedForm.vue?vue&type=script&lang=js&"
export * from "./GetStartedForm.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports